import { getDomainsData } from "../../../helpers/helpers";
import type { OrganicPaidTableAction, TransformedDataTable } from "../types";

export const reducer = (state: TransformedDataTable, action: OrganicPaidTableAction): TransformedDataTable => {
    const domainsDataMap = getDomainsData();

    switch (action.type) {
        case "SET_ORGANIC_PAID_DATA": {
            const newState = { ...state };

            for (const [domain, domainData] of Object.entries(action.payload)) {
                if (!domainData) {
                    continue;
                }
                newState[domain] = {
                    ...newState[domain],
                    domain: domainsDataMap[domain],
                    organic: { ...newState[domain]?.organic, ...domainData?.organic },
                    paid: { ...newState[domain]?.paid, ...domainData?.paid },
                    percentageOf: domainData?.percentageOf,
                };
            }
            return newState;
        }

        case "SET_KEYWORDS_DATA": {
            const newState = { ...state };
            for (const [domain, keywordsData] of Object.entries(action.payload)) {
                if (!keywordsData) {
                    continue;
                }
                newState[domain] = {
                    ...newState[domain],
                    domain: domainsDataMap[domain],
                    [action.sourceType]: {
                        ...newState[domain]?.[action.sourceType],
                        ...keywordsData,
                    },
                };
            }
            return newState;
        }
    }
};
